import Landing from "../pages/landing";

import "./index.css";

export default function Main() {
  return (
    <>
      <div
        className=""
        style={{
          display: 'flex',
          justifyContent: 'center',
      
        }}
      >
        <Landing />
      </div>
    </>
  );
}
